module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/hydrangea-right-icon-488e8175b53118297b6e93bb5e9d7654.svg";